import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import axios from 'utils/axios';
import AxiosAdmin from 'utils/axiosAdmin';
import URL from 'config/url';

export const getResort = createAsyncThunk('GET RESORTS', async (data, thunkAPI) => {
  let query = `?page=${data.page}&page_size=${data.pageSize}&limit=${data.limit}&text=${data.text}&booking_status=${data.bookingStatus}&currency=${data.currency}&payment_gateway=${data.paymentGateway}&booking_start_date=${data.startDate}&booking_end_date=${data.endDate}&sorting=${data.sorting}&user_type=${data.userType}&sorting_field=${data.sortingField}&travel_start_date=${data.travelStartDate}&travel_end_date=${data.travelEndDate}&agency_name=${data.agencyName}&cogs=${data.cogs}&cogs_paid_date=${data.cogsPaidDate}&agency_id=${data?.agencyId}&agency_commission_paid=${data.agencyCommissionPaid}&agency_commission_paid_date=${data.agencyCommissionPaidDate}&non_login=${data.isNonLogin}&payment_method_type=${data.paymentMethodTypes}`;
  const response = await AxiosAdmin.get(`${URL.RESORT_BOOKINGS}${query}`, thunkAPI);
  return response.data;
});

export const getResortDetails = createAsyncThunk('GET RESORTS DETAILS', async (data, thunkAPI) => {
  let query = `?id=${data.referenceNumber}`;
  const response = await AxiosAdmin.get(`${URL.RESORT_BOOKINGS}${query}`, thunkAPI);
  return response.data;
});

/*export const updateResortBooking = createAsyncThunk('UPDATE_RESORT_BOOKING', async (data, thunkAPI) => {
  const response = await axios.put(`${URL.UPDATE_RESORT_BOOKING}?id=${data.referenceNumber}`, data, thunkAPI);
  return response.data;
});*/

export const updateResortRemarks = createAsyncThunk('UPDATE_RESORT_REMARKS', async (data, thunkAPI) => {
  let requestData = {
    remark_id: data?.remark_id || "",
    remark: data?.remark,
  };
  const response = await AxiosAdmin.put(`${URL.RESORT_UPDATE}?id=${data.referenceNumber}`, requestData, thunkAPI);
  return response.data;
});

export const updateResortBooking = createAsyncThunk('UPDATE_RESORT_BOOKING', async (data, thunkAPI) => {
  const response = await AxiosAdmin.put(`${URL.RESORT_UPDATE}?id=${data.referenceNumber}`, data, thunkAPI);
  return response.data;
});

const initialState = {
  isLoading: false,
  resortData: null,
  resortDetails: null,
};

export const resortSlice = createSlice({
  name: 'resort',
  initialState,
  reducers: {},
  extraReducers: {
    [getResort.pending]: (state) => {
      state.isLoading = true;
      state.resortData = null;
    },
    [getResort.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.resortData = action.payload.data;
    },
    [getResort.rejected]: (state, action) => {
      state.isLoading = false;
      state.resortData = null;
      toast.error(action?.payload?.message);
    },
    [getResortDetails.pending]: (state) => {
      state.isLoading = true;
      state.resortDetails = null;
    },
    [getResortDetails.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.resortDetails = action.payload.data;
    },
    [getResortDetails.rejected]: (state, action) => {
      state.isLoading = false;
      state.resortDetails = null;
      toast.error(action?.payload?.message);
    },

    [updateResortBooking.pending]: (state) => {
      state.isLoading = true;
    },
    [updateResortBooking.fulfilled]: (state, action) => {
      state.isLoading = false;
      toast.success(action.payload?.message);
    },
    [updateResortBooking.rejected]: (state, action) => {
      state.isLoading = false;
      toast.error(action.payload?.message || 'Error updating cogs data');
    },
  },
});

export default resortSlice.reducer;
